module.exports = __webpack_public_path__ + "f5d6d14ffaccf25ca384d5763f3f5dcd.MP3";